/**
 * module-11.js
 *
 * Javascript for Module#11
 *
 * @package Wordpress/imhof-digital
 * @since   5.6.0
 * @author  Imhof Digital <info@imhof-digital.de>
 */

jQuery( document ).ready( function( $ ) {
  // declare strict mode
  'use strict';

   if( $( '.module-11' ) ) {
      /**
       * idscript.module_11
       *
       * @property   object      moduleContainer   The container of module 11
       * @property   array       tileContents      The contents of the tiles
       * @method     maxHeight()                   Checks the real height of the ul-elements
       * @method     adjustLists()                 Adjusts the lists to equal height
       * @method     init()                        Initiate the module 11 object
       */
      idscript.module_11 = {

         /**
          * @var     object   moduleContainer
          *
          * @since   5.6.0
          * @usedby  method   self::init()
          */
         moduleContainer: '',

         /**
          * @var     array    tileContents
          *
          * @since   5.6.0
          * @usedby  method   self::maxHeight()
          * @usedby  method   self::adjustLists()
          * @usedby  method   self::init()
          */
         tileContents: '',

         /**
          * maxHeight()
          *
          * @since   5.6.0
          * @uses    property self::tileContents
          * @usedby  method   self::adjustLists()
          * @return  integer  maxHeight   The maximal height of an ul-element
          */
         maxHeight: function() {
            var maxHeight = 0;
            $( idscript.module_11.tileContents ).each( function( index, element ) {
               var actualHeight = $( element ).find( 'ul' ).css( 'height', 'auto' ).height();
               maxHeight = actualHeight > maxHeight ? actualHeight : maxHeight;
            } );
            return maxHeight;
         },

         /**
          * adjustLists()
          *
          * @since   5.6.0
          * @uses    property self::tileContents
          * @uses    method   self::maxHeight()
          * @return  void
          */
         adjustLists: function() {
            var height = 0;
            if( window.innerWidth >= '1024' ) {
               height = ( idscript.module_11.maxHeight() / 16 ) +'rem';
            } else {
               height = 'auto';
            }
            $( idscript.module_11.tileContents ).each( function( index, element ) {
               $( element ).find( 'ul' ).css( 'height', height );
            } );
            return;
         },

         /**
          * init()
          *
          * @since   5.6.0
          * @uses    property self::moduleContainer
          * @uses    property self::tileContents
          * @uses    method   self::adjustLists()
          * @return  void
          */
         init:function() {
            idscript.module_11.moduleContainer = $( '.module-11' );
            idscript.module_11.tileContents = $( idscript.module_11.moduleContainer ).find( '.module-11.tile.content' );
            idscript.module_11.adjustLists();
            $( window ).on( 'resize', function() {
               idscript.module_11.adjustLists();
            } );
            return;
         }
      };
      idscript.module_11.init();
   }
} );
